type PainPointCardProps = {
  index: number;
  title: string;
  description: string;
};

export default function PainPointCard({ index, title, description }: PainPointCardProps) {
  const bgIndex = String(index + 1).padStart(2, '0');
  const cardBgUrl = `images/bg-${bgIndex}.jpg`;
  const iconUrl = `images/index${bgIndex}.png`;
  const delay = index === 0 ? 600 : 400;

  return (
    <div
      data-aos="flip-left"
      className="p-[30px] box-content bg-no-repeat bg-cover"
      style={{ backgroundImage: `url(${cardBgUrl})` }}
    >
      <i
        data-aos="zoom-in"
        data-aos-delay="300"
        className="block w-[90px] h-[90px] my-[10px] mb-[20px] bg-no-repeat bg-center"
        style={{ backgroundImage: `url(${iconUrl})` }}
      ></i>
      <h3
        data-aos="fade-up"
        data-aos-delay={delay}
        className="text-[24px] font-bold text-white leading-[30px] pb-[8px]"
      >
        {title}
      </h3>
      <p
        data-aos="fade-up"
        data-aos-delay={delay}
        className="text-[16px] text-white leading-[26px] text-left"
      >
        {description}
      </p>
    </div>
  );
}

